import { useDispatch } from 'react-redux';

import { Celebration } from '../../uiKit/assets/svg/celebration.js'
import Feedback from '../../components/Feedback/feedback.js';

import { setAllThankOpen } from '../../redux/state/donationSlice.js';

const DonateAllThankYou = () => {
    const dispatch = useDispatch();

    const closeAllThankHandler = () => dispatch(setAllThankOpen(false));

    return (
        <div className='createdPage'>
            <Feedback
                title="Thank you"
                firstDescription='You have helped your community.'
                secondDescription='Be proud.'
                button={{
                    feedbackTitle: 'Close',
                    feedbackAction: closeAllThankHandler,
                    disable: false
                }}
                Image={Celebration}
                titleFontSize={24}
            />
        </div>
    )
}

export default DonateAllThankYou;